import { analysisLog } from "@/utils/logAnalytics";

const getFileIdsAndTypes = (fileList: any[]) => {
  let fileIds: string[] = [];
  let fileTypes: string[] = [];
  fileList.forEach(({ fileType = "", fileId = "", pageType, id, page_type }) => {
    fileIds.push(fileId || id || "");
    const fileTypeArr = fileType.split("/");
    fileTypes.push(
      fileTypeArr.length >= 3 ? fileType.split("/")[1] : page_type || pageType || fileType
    );
  });
  return { fileIds, fileTypes };
};

export const doAddJoyspacesAnalysisLog = (fileList: any[], id = "") => {
  const { fileIds, fileTypes } = getFileIdsAndTypes(fileList);
  console.log(
    "xtbg_jzb_joysapce_inOtherModule_1676971574856",
    id || "4",
    fileTypes.join("/"),
    fileIds.join("/")
  );
  analysisLog(
    "xtbg_jzb_joysapce_inOtherModule_1676971574856",
    id || "4",
    fileTypes.join("/"),
    fileIds.join("/")
  );
};
